import { ApolloLink } from '@apollo/client'

export default function createRefererLink() {
  return new ApolloLink((operation, forward) => {
    // Capture the current window URL at the time the request is made
    const currentUrl = typeof window !== 'undefined' ? window.location.href : ''

    if (currentUrl) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          'X-Client-Referer': currentUrl,
        },
      }))
    }

    return forward(operation)
  })
}
